import React from "react";
import "./ServicesDetail.css";
const ServicesDetail = ({txt1, txt2,extra, textRight}) => {
  return (
    <div className="services-details">
      <h4 >{txt1}</h4>
      <p >{txt2}</p>
    <div className="btn-services">
        <button>Learn More </button>
    </div>
    </div>
  );
};

export default ServicesDetail;
